import React from "react";
import "../styles/Blogs.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const blogData = [
  {
    title: "Empowering Entrepreneurs By Automating Application Development",
    img: "images/Automation_img1.png",
    link: "/blogs/AutomatingApplicationDevelopment",
    desc: "As a business entrepreneur, what resources would you employ to create the most cutting-edge application possible?",
  },
  {
    title:
      "Leveraging The Benefits of Cloud Native Services Without Facing Vendor Lock-In",
    img: "images/CloudNative_img2.png",
    link: "/blogs/CloudNativeServices",
    desc: "Have you ever bought something from a third party before, and at some time you considered making a switch to a similar offering from a different seller?",
  },
  {
    title:
      "Continuous Modernization: The Changing Face of Modern Application Development",
    img: "images/ModernApplication_img3.png",
    link: "/blogs/ModernApplicationDevelopment",
    desc: "In a survey conducted in 2021, found that 71% of businesses were updating 25% or more of their applications",
  },
  {
    title:
      "How Automation Transforms Software Development for Faster Time-to-Market",
    img: "images/AutomationDevelopment.png",
    link: "/blogs/AutomationTransformsSoftware",
    desc: "Automation is reshaping software development by reducing manual effort and human error. It ensuring consistency and efficiency.",
  },
  {
    title:
      "Building Smarter Apps: The Power of API-Driven Microservices in 2025",
    img: "images/BuildingSmarterApps.png",
    link: "/blogs/BuildingSmarterApps",
    desc: "The future of application development isn’t just about faster coding; it’s about smarter, more scalable, and more adaptable applications. In 2025",
  },
];

const Blogs = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="B_container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h1
        className="blogs_heading"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        Blogs
      </motion.h1>

      <div className="B_card_container">
        {blogData.map((blog, index) => (
          <motion.div
            className="B_card"
            key={index}
            initial={{ opacity: 0, scale: 0.95, y: 30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.5,
              delay: index * 0.2,
              ease: "easeInOut",
            }}
          >
            <img src="images/gradient_bar.png" alt="gradient" />
            <h6>{blog.title}</h6>
            <img className="b_card_img2" src={blog.img} alt={blog.title} />
            <p>{blog.desc}</p>
            <button
              onClick={() => navigate(blog.link)}
              className="btn_first_rm"
            >
              Read More
            </button>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Blogs;
